import { Leader } from './../../shared/types';
import { createEvent } from "@cobuildlab/react-simple-state";

export const OnFetchLeaders = createEvent<Leader[]>();
export const OnFetchLeadersError = createEvent();
